import axios from 'axios'
import { store } from 'store/index'
import {
  addNewMessage,
  removeAllMessages,
  selectChatId,
  selectOpenChatLoading,
  setChatId,
  setChatRole,
  setOpenChatLoading,
} from 'store/messages'
import { DateTime } from 'luxon'
import { ChatRole } from 'types/index'
import ObjectID from 'bson-objectid'
import { t } from 'i18next'
import { captchaAxios } from 'api/config'

export const getGuestChat = async () => {
  try {
    const state = store.getState()
    const loading = selectOpenChatLoading(state)
    const chatId = selectChatId(state)
    if (loading || chatId) {
      return
    }
    store.dispatch(setOpenChatLoading(true))
    const { data } = await axios.get<{ _id: string }>('chat/guest')
    store.dispatch(setChatId(data._id))
    store.dispatch(setOpenChatLoading(false))
    return data
  } catch (e) {
    console.error({ e })
    store.dispatch(setChatId(undefined))
    store.dispatch(setOpenChatLoading(false))
    store.dispatch({
      text: "Unfortunately, I'm having some problem 😅. I would appreciate it if you could try again later",
      sender: 'BOT',
      type: 'text',
      ts: DateTime.now().toISO(),
    })
  }
}

export const openNewGuestChat = async () => {
  try {
    store.dispatch(setOpenChatLoading(true))
    const { data } = await axios.get<{ _id: string }>('chat/guest')
    store.dispatch(setChatId(data._id))
    store.dispatch(setChatId(data._id))
    store.dispatch(setOpenChatLoading(false))
  } catch (e) {
    console.error({ e })
    store.dispatch(setChatId(undefined))
    store.dispatch(setOpenChatLoading(false))
    store.dispatch({
      text: "Unfortunately, I'm having some problem 😅. I would appreciate it if you could try again later",
      sender: 'BOT',
      type: 'text',
      ts: DateTime.now().toISO(),
    })
  }
}

export const updateChatRole = async (role: ChatRole, textByRole = true) => {
  const state = store.getState()
  const chatId = selectChatId(state)

  if (!chatId) {
    return Promise.reject('No chatId')
  }

  try {
    await captchaAxios.put(`chat/${chatId}/role/${role}`, {})
    store.dispatch(setChatRole(role))
    store.dispatch(removeAllMessages())
    store.dispatch(
      addNewMessage({
        text: textByRole ? t(`select-${role}-ResponseText`) : t('welcomeOne'),
        sender: 'BOT',
        type: 'text',
        isWelcomeMessage: true,
        ts: DateTime.now().toISO(),
        id: String(ObjectID()),
      }),
    )
  } catch (e) {
    return Promise.resolve(undefined)
  }
}
